// Module
var code = `<template class="ag-searchable-select-editor">
  <require from="./agSearchableSelectEditor.scss"></require>

  <div class="searchable-select-container">
    <div class="searchable-select-search">
      <input ref="inputElement" type="text" value.bind="searchText" placeholder="Type to search..." keydown.trigger="handleKeyDown(\$event)" input.trigger="onSearchInput(\$event)">
    </div>
    <div class="searchable-select-options" ref="optionsContainer">
      <div repeat.for="option of filteredOptions" class="ag-searchable-select-option \${\$index === highlightedIndex ? 'highlighted' : ''} \${option.value === selectedValue ? 'selected' : ''}" click.trigger="selectOption(option)" mouseenter.delegate="highlightedIndex = \$index">
        <span if.bind="option.value === null" class="none-option">\${option.label}</span>
        <span else>\${option.label}</span>
      </div>
      <div if.bind="filteredOptions.length === 0" class="searchable-select-no-results">
        No results found
      </div>
    </div>
    <div if.bind="allowCustomValue" class="searchable-select-custom">
      <input ref="customValueInput" type="text" value.bind="customValue" placeholder="Or type a custom value..." input.trigger="onCustomValueInput()" keydown.trigger="handleCustomKeyDown(\$event)">
    </div>
  </div>
</template>
`;
// Exports
export default code;